import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1,
      position: 'relative',
      minHeight: '100vh',
      paddingInlineEnd: 56,
      paddingInlineStart: 56,

      '@media (max-width: 1180px)': {
        paddingInlineStart: 0,
        paddingInlineEnd: 0,
      },
    },
    pageTitle: {
      height: 98,
      gap: 16,
      paddingTop: 40,
    },
    title: {
      fontWeight: 600,
      fontSize: 32,
      color: variables.richBlack,
    },
  }),
);
